<template>
    <div class="expert-management">
        <!-- 引入通用表格组件 -->
        <UniversalDataTable
            :columns="expertColumns"
            :form-fields="expertFormFields"
            :table-data="tableData"
            :pagination="pagination"
            :form-rules="expertFormRules"
            :uploadUrl="uploadImgUrl"
            :enable-selection="true"
            :enable-edit="true"
            :enable-delete="true"
            @search="handleSearch"
            @create="handleCreate"
            @update="handleUpdate"
            @delete="handleDelete"
            @pagination-change="handlePaginationChange"
            @selection-change="handleSelectionChange" />
    </div>
</template>

<script>
// 引入通用表格组件（确保路径正确）
import UniversalDataTable from '@/components/common/commonTable.vue';
import expertApi from '@/api/experts.js'; // 人才/专家接口文件
import InstitutionApi from '@/api/institutions.js'; // 人才/专家接口文件
import baseData from '@/api/base.js';
import { sliceImgUrl } from '@/utils/MyUtils.js'

export default {
    name: 'ExpertManagement',
    components: {
        UniversalDataTable
    },
    data() {
        return {
            // 表格数据（实际从接口获取）
            tableData: [],
            // 分页配置
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            // 搜索相关
            keyword: '',
            uploadImgUrl: baseData.IMG_BASE_URL,
            institutionsOptions: []
        };
    },
    computed: {
        // 基础分页查询URL
        baseUrl() {
            return `/experts/page?pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}&name=${this.keyword}`
        },
        // 表格列配置（对应专家数据字段）
        expertColumns() {
            return [
                {
                    prop: 'id',
                    label: 'ID',
                    width: 80,
                    align: 'center'
                },
                {
                    prop: 'name',
                    label: '姓名',
                    width: 120
                },
                {
                    prop: 'titles',
                    label: '头衔',
                    type: 'tag-list',
                    width: 200,
                },
                {
                    prop: 'researchFields',
                    label: '研究领域',
                    type: 'tag-list',
                    width: 250,
                },
                {
                    prop: 'institutions',
                    label: '所属机构',
                    // type: 'tag-list',
                    width: 250,
                    formatter: (value) => {
                        if (!value) return '';
                        return value.map(item => item.name).join(",")
                    }
                },
                {
                    prop: 'bio',
                    label: '个人简介',
                    // 超长文本截取显示（hover 显示完整内容）
                    formatter: (value) => {
                        if (!value) return '';
                        return value.length > 40 ? `${value.slice(0, 40)}...` : value;
                    }
                },
                {
                    prop: 'avatar',
                    label: '头像',
                    type: 'image',  // 触发通用组件的图片特殊处理
                    width: 100,
                    align: 'center'
                }
            ];
        },

        // 表单字段配置（新增/编辑弹窗用）
        expertFormFields() {
            return [
                {
                    prop: 'name',
                    label: '姓名',
                    type: 'input',
                    required: true,
                    props: {
                        placeholder: '请输入专家姓名'
                    }
                },
                {
                    prop: 'titles',
                    label: '头衔',
                    type: 'tag-input',
                    required: true,
                    props: {
                        placeholder: '请输入头衔，多个头衔用英文逗号分隔（如：教授,博导,研究员）'
                    },

                },
                {
                    prop: 'researchFields',
                    label: '研究领域',
                    type: 'tag-input',
                    required: false,
                    props: {
                        placeholder: '请输入研究领域，多个领域用英文逗号分隔（如：人工智能,机器学习,计算机视觉）'
                    },
                },
                {
                    prop: 'ids',
                    label: '所属机构',
                    type: 'select',
                    required: false,
                    options: this.institutionsOptions
                },
                {
                    prop: 'bio',
                    label: '个人简介',
                    type: 'input',
                    required: true,
                    props: {
                        type: 'textarea',  // 多行文本框
                        rows: 6,
                        placeholder: '请输入专家个人简介'
                    }
                },
                {
                    prop: 'avatar',
                    label: '头像',
                    type: 'image-upload',
                    uploadUrl: baseData.IMG_BASE_URL,
                    required: false,  // 头像非必填
                    limit: 1, // 限制仅能上传1张图片
                    hint: '支持 JPG、PNG、WEBP 格式，大小不超过 2MB，仅可上传1张',
                    props: {
                        // 可额外配置上传参数
                    }
                }
            ];
        },
        // 表单验证规则
        expertFormRules() {
            return {
                name: [
                    { required: true, message: '请输入专家姓名', trigger: 'blur' }
                ],
                bio: [
                    { required: true, message: '请输入个人简介', trigger: 'blur' }
                ]
            };
        }
    },
    mounted() {
        this.genInstitutionsOptions()
        this.loadExpertList(this.baseUrl)
    },
    methods: {
        // ---------------------- 数据接口相关 ----------------------
        async genInstitutionsOptions() {
            let objs = (await InstitutionApi.getAll()).data;
            this.institutionsOptions = objs.map(item => { return { "label": item.name, "value": item.id } })
        },
        // 加载专家列表数据
        async loadExpertList(url) {
            try {
                const response = await this.$http.get(url);
                this.pagination.total = response.data.total;
                this.tableData = response.data.records;
                console.log(this.tableData)
                // 处理图片URL（复用现有工具方法，指定头像字段）
                sliceImgUrl(this.tableData, 'avatar')
                this.error = null;
            } catch (err) {
                this.error = '数据加载失败，请稍后重试';
                console.error('加载专家数据出错:', err);
            }
        },

        // ---------------------- 通用表格回调函数 ----------------------
        // 搜索回调（关键词搜索）
        handleSearch(keyword) {
            console.log('搜索关键词：', keyword);
            this.keyword = keyword
            this.pagination.currentPage = 1;
            this.loadExpertList(this.baseUrl)
        },

        // 新增数据回调
        async handleCreate(formData) {
            try {
                const res = await expertApi.create(formData, {ids:formData.ids});
                if (res.code == 200) {
                    this.$message.success(res.msg || '新增成功');
                    // 重新加载列表数据
                    this.loadExpertList(this.baseUrl);
                }
            } catch (error) {
                this.$message.error('新增失败：' + (error.msg || res.msg || '网络错误'));
            }
        },

        // 编辑数据回调
        async handleUpdate(formData) {
            try {
                // 确保携带主键 id（后端需通过主键更新）
                if (!formData.id) {
                    this.$message.error('专家ID不能为空');
                    return;
                }
                const res = await expertApi.update(formData,{ids:(formData.ids ||null)});
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    this.loadExpertList(this.baseUrl);
                }
            } catch (error) {
                this.$message.error('编辑失败：' + (error.msg || '网络错误'));
            }
        },

        // 删除数据回调
        async handleDelete(row) {
            console.log('删除专家数据：', row.id);
            try {
                const res = await expertApi.delete(row.id);
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    this.loadExpertList(this.baseUrl);
                }
            } catch (err) {
                this.$message.error('删除失败' + (err.msg || '网络错误'))
            }
        },

        // 分页变化回调
        handlePaginationChange(pagination) {
            this.pagination = pagination;
            this.loadExpertList(this.baseUrl);
        },

        // 选择行变化回调
        handleSelectionChange(selectedRows) {
            console.log('选中的专家：', selectedRows);
            // 可用于批量操作（如批量删除、批量导出等）
        }
    },
};
</script>

<style scoped>
.expert-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}
</style>